import { render } from "./UI.vue?vue&type=template&id=dd99dda2"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"

import "./UI.vue?vue&type=style&index=0&id=dd99dda2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__